/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import CLog, { LogTypes } from './ComponentLogger';

export default class LoggableCustomEvent extends cc.Event.EventCustom
{
    public EventName: string = "Loggable.CustomEvent";

    public constructor(eventName: string, bubbles?: boolean)
    {
        super(eventName, bubbles);

        this.EventName = eventName;

        if (CC_DEBUG && eventName !== 'StateEvent')
        {
            CLog.log(`Event Created: [${eventName}]`, LogTypes.Initialization);
        }
    }
}
